import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var ErrorMessage = /*#__PURE__*/function () {
  /**
   * @param {string} primary
   * @param {string[]} secondary
   */
  function ErrorMessage(primary) {
    var secondary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, ErrorMessage);

    this.primary = primary;
    this.secondary = secondary;
  }
  /**
   * @param {string} primary
   *
   * @returns {ErrorMessage}
   */


  _createClass(ErrorMessage, [{
    key: "setPrimary",
    value: function setPrimary(primary) {
      this.primary = primary;
      return this;
    }
    /**
     * @returns {string}
     */

  }, {
    key: "getPrimary",
    value: function getPrimary() {
      return this.primary;
    }
    /**
     * @param {string[]} secondary
     *
     * @returns {ErrorMessage}
     */

  }, {
    key: "setSecondary",
    value: function setSecondary(secondary) {
      this.secondary = secondary;
      return this;
    }
    /**
     * @returns {string[]}
     */

  }, {
    key: "getSecondary",
    value: function getSecondary() {
      return this.secondary;
    }
  }]);

  return ErrorMessage;
}();

export default ErrorMessage;